const testimonials = [
  {
    quote:
      "Luxe-Tech transformed our entire IT infrastructure in under 6 months. Our team's productivity increased by 40% and downtime dropped to near zero.",
    name: "Sarah Mitchell",
    title: "CTO, FinEdge Capital",
    initials: "SM",
    color: "bg-sky-500",
  },
  {
    quote:
      "Their cybersecurity team identified critical vulnerabilities in our systems that our internal team had missed for years. Exceptional depth of expertise.",
    name: "James Reyes",
    title: "VP Engineering, MedCore Health",
    initials: "JR",
    color: "bg-indigo-500",
  },
  {
    quote:
      "The cloud migration was seamless with zero business disruption. Luxe-Tech's project management and communication throughout were world-class.",
    name: "Angela Thornton",
    title: "COO, NovaTrade Logistics",
    initials: "AT",
    color: "bg-violet-500",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 px-4 bg-white dark:bg-slate-900">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16 space-y-4">
          <span className="inline-block text-sm font-medium px-4 py-1.5 rounded-full bg-sky-100 dark:bg-sky-500/10 text-sky-600 dark:text-sky-400 border border-sky-200 dark:border-sky-500/20">
            Client Stories
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white">
            Trusted by Industry Leaders
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
            Hear from the organizations that have partnered with us to build stronger, more resilient technology foundations.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 flex flex-col gap-6 hover:shadow-lg transition-shadow duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-amber-400 text-lg">★</span>
                ))}
              </div>

              <blockquote className="text-slate-700 dark:text-slate-300 leading-relaxed flex-1">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-3 pt-2 border-t border-slate-200 dark:border-slate-700">
                <div
                  className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-white text-sm font-bold flex-shrink-0`}
                >
                  {t.initials}
                </div>
                <div>
                  <div className="font-semibold text-slate-900 dark:text-white text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500 dark:text-slate-400">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
